import React from 'react'

import styles from './KBList.module.css'

import PageLoader from 'Layout/PageLoader'

import KBTile from '../KBTile'
import ImportKB from '../ImportKB'
import { useListKbsQuery } from '../kb.service'

const KBList = () => {
  const { isLoading, isFetching, data: kbs = [] } = useListKbsQuery()

  if (isLoading) {
    return <PageLoader />
  }

  if (kbs.length === 0) {
    return <ImportKB hideBackButton />
  }

  return (
    <div className={styles.ListContainer}>
      {kbs.map((kb) => {
        return (
          <KBTile
            isFetching={isFetching}
            key={'KnowledgeBaseList' + kb.id}
            id={kb.id}
            name={kb.name}
            source={kb.settings.account_url}
            noOfarticles={kb.articles_count}
            ignoredSections={kb.ignored_sections}
            type={kb.source_type}
            syncStatus={kb.sync_status}
            lastSyncAt={kb.last_sync_at}
          />
        )
      })}
    </div>
  )
}

export default KBList
